import React from 'react';

import SvgProductsNoRes from '../../../assets/images/svg-components/ProductsNoRes';
import { useScreenSize } from '../../hooks/use-screen-size';

import { useStyles } from './style';

interface Props {
  isFavSelected?: boolean;
}

export const NoSearchResultsRestaurant: React.FC<Props> = ({ isFavSelected = false }) => {
  const classes = useStyles();
  const { isDesktop } = useScreenSize();

  return (
    <div className={classes.noResBlock}>
      {
      isFavSelected
        ? <>
            <h3 className={classes.noResTitle}>No favourites found.</h3>
            <p className={classes.noResText}>Try adjusting your search or turning off the favourites filter to see more products.</p>
          </>
        : <>
            <h3 className={classes.noResTitle}>Hmmm.. we couldn’t find any results for you.</h3>
            <p className={classes.noResText}>Please check the spelling or try a broader search.</p>
          </>
      }
      <SvgProductsNoRes width={isDesktop ? 180 : 160} height={isDesktop ? 180 : 160} />
    </div>
  );
};
